import {IMailData} from "../Types/IMailData";

export const PLACEHOLDER_MAIL_DATA: Record<string, IMailData> = {
    "PLACEHOLDER_1": {
        to: "You",
        subject: "Test email",
        from: "IT Administrator",
        contents: "Lorum Ipsum.\n\n...What?",
    },
    "PLACEHOLDER_2": {
        to: "You",
        subject: "Penis enlargement pills! For sale!",
        from: "Big McPenis",
        contents: "Heyyyy wanna buy some pilllllls?!",
    },
    "RANK_UP_EMAIL_1": {
        to: "You",
        subject: "Congratulations on getting in as a med student!",
        from: "Dean of Medicine",
        contents: "Just dropping an email to say congrats on joining us as a <bold>Med Student</bold>! You're going places!",
    },
    "RANK_UP_EMAIL_2": {
        to: "You",
        subject: "Congratulations on getting the internship!",
        from: "Dean of Medicine",
        contents: "placeholder",
    },
    "RANK_UP_EMAIL_3": {
        to: "You",
        subject: "Congratulations on your promotion to Junior Resident!",
        from: "Dean of Medicine",
        contents: "placeholder",
    },
    "RANK_UP_EMAIL_4": {
        to: "You",
        subject: "Congratulations on your promotion to Resident!",
        from: "Dean of Medicine",
        contents: "placeholder",
    },
    "RANK_UP_EMAIL_5": {
        to: "You",
        subject: "Congratulations on your promotion to Senior Resident!",
        from: "Dean of Medicine",
        contents: "placeholder",
    },
    "RANK_UP_EMAIL_6": {
        to: "You",
        subject: "Congratulations on your promotion to Co-Chief Resident!",
        from: "Dean of Medicine",
        contents: "placeholder",
    },
    "RANK_UP_EMAIL_7": {
        to: "You",
        subject: "Whoops, I mean Chief Resident!",
        from: "Dean of Medicine",
        contents: "placeholder",
    },
    "RANK_UP_EMAIL_8": {
        to: "You",
        subject: "Congratulations on your promotion to Fellow!",
        from: "Dean of Medicine",
        contents: "placeholder",
    },
    "RANK_UP_EMAIL_9": {
        to: "You",
        subject: "Congratulations on your promotion to Attending!",
        from: "Dean of Medicine",
        contents: "placeholder",
    },
    "RANK_UP_EMAIL_10": {
        to: "You",
        subject: "Congratulations on your promotion to Head of Diagnostics!",
        from: "Dean of Medicine",
        contents: "placeholder",
    },
    "RANK_UP_EMAIL_11": {
        to: "You",
        subject: "Congratulations on your promotion to Dean of Medicine!",
        from: "Dean of Medicine",
        contents: "Wait, shit, that's my job.",
    },
    "INTRODUCTION": {
        to: "You",
        subject: "Welcome to DoctOS!",
        from: "IT Administrator",
        contents: `Hey newbie,
        
If you're reading this, you must have figured out how to use the login details I left sticky-noted to your screen, congrats!

Welcome to the wondrous world of DoctOS, the cutting-edge operating system built for the biggest-scale of hospitals in 2030. With the latest software like Internet Traveller 8.0 and Doctors Mail Server 95, you'll find the process of diagnosing patients even more streamlined than ever.
It might seem a little strange to give diagnostic cases en masse to interns, but with our revolutionary method of triage via AI prompts, we're able to streamline the process enough that anyone with a computer can diagnose!
...Not that I'm saying that you're just anyone! (ㆆ _ ㆆ)

To get started, you can simply click the Start menu in the bottom-left corner, and select "Select-a-Case"! From there you will be given a choice of two cases to take, and you can take up to <bold>five</bold> cases at a time. 
When you receive a case, it'll get pinned to the top of your inbox so you can easily find it later. This email will contain links to the parts of DoctOS that'll allow you to schedule procedures, examinations, and ultimately make diagnoses.

Give it a try! And don't forget, diagnosing is the last step of the process, so make sure to treat as many symptoms as you can before making your diagnosis! We are doctors after all! (well, you are!)

If you ever get stuck, you can access the Help software from your Start menu too.

Have fun!
IT Administrator`,
    },
};